
export default [
    {
        path: '/app/services',
        name: 'app.services',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-services-sms" */ './../views/App/Services/Dashboard.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/campaign',
        name: 'app.services.sms',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-services-sms" */ './../views/App/Services/Sms/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/campaign/create',
        name: 'app.services.sms.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-services-sms-create" */ './../views/App/Services/Sms/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/campaign/create/variables',
        name: 'app.services.sms.create.variables',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-services-sms-create-variables" */ './../views/App/Services/Sms/CreateVars.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/campaign/details/:id',
        name: 'app.services.sms.details',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-services-sms-details" */ './../views/App/Services/Sms/Details.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/reports',
        name: 'app.services.reports',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-reports" */ './../views/App/Services/Reports/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/reports/general',
        name: 'app.services.reports.general.index',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-reports-general" */ './../views/App/Services/Reports/General/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/reports/synthetic',
        name: 'app.services.reports.synthetic.index',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-reports-synthetic" */ './../views/App/Services/Reports/Synthetic/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U'],
            permition_company: ['R']
        }
    },
    {
        path: '/app/services/reports/analytical',
        name: 'app.services.reports.analytical.index',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-reports-analytical" */ './../views/App/Services/Reports/Analytical/List.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/reports/analytical/create',
        name: 'app.services.reports.analytical.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-reports-analytical-create" */ './../views/App/Services/Reports/Analytical/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/responses',
        name: 'app.services.responses',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-responses" */ './../views/App/Services/Responses/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/services/status',
        name: 'app.services.status',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-sms-status" */ './../views/App/Services/Status/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    }
]
